import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ModelosService {

  
  constructor(private http: HttpClient) {
  }

  getAll() {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        })
      };
      const url = `${environment.base_url}/hino/camiones/all`;
      return this.http.get<any>(url, httpOptions)
  }

  getSerieModelo(serie:any) {
    const httpOptionsTwo = {
      headers: new HttpHeaders({
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      })
    };    
    const urlTwo = `${environment.base_url}/hino/camiones/${serie}/caracteristicas`;
    return this.http.get<any>(urlTwo, httpOptionsTwo);
  }
}